import { NgModule } from '@angular/core';

import { SharedModule } from "../../shared/shared.module";
import { VisitantesComponent } from "./visitantes.component";
import { VisitantesRoutingModule } from "./visitantes-routing.module";
import { ViagensModule } from "../../viagens/viagens.module";

@NgModule({
    imports: [
        SharedModule,
        ViagensModule,
        VisitantesRoutingModule
    ],
    declarations: [
        VisitantesComponent
    ]
})
export class VisitantesModule { }



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/pages/visitante/visitantes.module.ts
 **/